import { useState, useEffect, useRef } from "react";
import { createClient } from "@supabase/supabase-js";

const supabase = createClient(
  "https://hhoweiydxfuoxwrsikyd.supabase.co",
  "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Imhob3dlaXlkeGZ1b3h3cnNpa3lkIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NzMzNjkxNjcsImV4cCI6MjA4ODk0NTE2N30.Qit2wLLbtrfY0ba4s4R7M7tCBg35YiYnCU--YuDXQKk"
);

// Cartoon field SVG as data URL
const FIELD_SVG = `data:image/svg+xml;utf8,${encodeURIComponent(`<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1200 700">
  <defs>
    <radialGradient id="skyGrad" cx="50%" cy="40%" r="70%">
      <stop offset="0%" stop-color="#1a2a5e"/>
      <stop offset="100%" stop-color="#0a0e28"/>
    </radialGradient>
    <radialGradient id="fieldGrad" cx="50%" cy="50%" r="60%">
      <stop offset="0%" stop-color="#1a3a1a"/>
      <stop offset="100%" stop-color="#0e2010"/>
    </radialGradient>
    <filter id="blur1"><feGaussianBlur stdDeviation="2"/></filter>
    <filter id="glow"><feGaussianBlur stdDeviation="3" result="blur"/><feMerge><feMergeNode in="blur"/><feMergeNode in="SourceGraphic"/></feMerge></filter>
  </defs>
  <!-- Sky/ground background -->
  <rect width="1200" height="700" fill="url(#skyGrad)"/>
  <!-- Distant trees row - top -->
  <ellipse cx="80" cy="100" rx="55" ry="45" fill="#0e2218" opacity="0.9"/>
  <ellipse cx="140" cy="85" rx="50" ry="42" fill="#122a1e" opacity="0.9"/>
  <ellipse cx="200" cy="95" rx="48" ry="40" fill="#0e2218" opacity="0.9"/>
  <ellipse cx="280" cy="80" rx="60" ry="48" fill="#152e22" opacity="0.9"/>
  <ellipse cx="370" cy="90" rx="52" ry="44" fill="#0e2218" opacity="0.9"/>
  <ellipse cx="450" cy="75" rx="58" ry="46" fill="#122a1e" opacity="0.9"/>
  <ellipse cx="540" cy="88" rx="55" ry="43" fill="#0e2218" opacity="0.9"/>
  <ellipse cx="630" cy="78" rx="60" ry="47" fill="#152e22" opacity="0.9"/>
  <ellipse cx="720" cy="92" rx="52" ry="42" fill="#0e2218" opacity="0.9"/>
  <ellipse cx="800" cy="80" rx="56" ry="45" fill="#122a1e" opacity="0.9"/>
  <ellipse cx="880" cy="90" rx="54" ry="44" fill="#0e2218" opacity="0.9"/>
  <ellipse cx="960" cy="77" rx="58" ry="46" fill="#152e22" opacity="0.9"/>
  <ellipse cx="1050" cy="88" rx="52" ry="43" fill="#0e2218" opacity="0.9"/>
  <ellipse cx="1130" cy="82" rx="55" ry="45" fill="#122a1e" opacity="0.9"/>
  <!-- Trees right side -->
  <ellipse cx="1150" cy="200" rx="45" ry="55" fill="#0e2218" opacity="0.85"/>
  <ellipse cx="1170" cy="310" rx="42" ry="52" fill="#122a1e" opacity="0.85"/>
  <ellipse cx="1155" cy="420" rx="46" ry="54" fill="#0e2218" opacity="0.85"/>
  <ellipse cx="1165" cy="530" rx="43" ry="50" fill="#152e22" opacity="0.85"/>
  <!-- Trees left side -->
  <ellipse cx="50" cy="200" rx="45" ry="55" fill="#0e2218" opacity="0.85"/>
  <ellipse cx="35" cy="320" rx="42" ry="52" fill="#122a1e" opacity="0.85"/>
  <ellipse cx="52" cy="440" rx="46" ry="54" fill="#0e2218" opacity="0.85"/>
  <ellipse cx="38" cy="560" rx="43" ry="50" fill="#152e22" opacity="0.85"/>
  <!-- Bottom trees -->
  <ellipse cx="100" cy="640" rx="55" ry="45" fill="#0e2218" opacity="0.9"/>
  <ellipse cx="230" cy="655" rx="52" ry="44" fill="#122a1e" opacity="0.9"/>
  <ellipse cx="380" cy="645" rx="58" ry="46" fill="#0e2218" opacity="0.9"/>
  <ellipse cx="530" cy="658" rx="55" ry="43" fill="#152e22" opacity="0.9"/>
  <ellipse cx="680" cy="648" rx="60" ry="47" fill="#0e2218" opacity="0.9"/>
  <ellipse cx="820" cy="660" rx="52" ry="44" fill="#122a1e" opacity="0.9"/>
  <ellipse cx="960" cy="645" rx="56" ry="46" fill="#0e2218" opacity="0.9"/>
  <ellipse cx="1090" cy="655" rx="54" ry="45" fill="#152e22" opacity="0.9"/>
  <!-- Main field rectangle -->
  <rect x="120" y="130" width="960" height="440" rx="8" fill="url(#fieldGrad)"/>
  <!-- Alternating mow stripes -->
  <rect x="120" y="130" width="80" height="440" fill="#1e3a1e" opacity="0.4"/>
  <rect x="280" y="130" width="80" height="440" fill="#1e3a1e" opacity="0.4"/>
  <rect x="440" y="130" width="80" height="440" fill="#1e3a1e" opacity="0.4"/>
  <rect x="600" y="130" width="80" height="440" fill="#1e3a1e" opacity="0.4"/>
  <rect x="760" y="130" width="80" height="440" fill="#1e3a1e" opacity="0.4"/>
  <rect x="920" y="130" width="80" height="440" fill="#1e3a1e" opacity="0.4"/>
  <!-- Field border -->
  <rect x="150" y="158" width="900" height="384" rx="4" fill="none" stroke="#c9a227" stroke-width="2.5" opacity="0.9"/>
  <!-- Center line -->
  <line x1="600" y1="158" x2="600" y2="542" stroke="#c9a227" stroke-width="2" opacity="0.85"/>
  <!-- Center circle -->
  <circle cx="600" cy="350" r="70" fill="none" stroke="#c9a227" stroke-width="2" opacity="0.85"/>
  <circle cx="600" cy="350" r="4" fill="#c9a227" opacity="0.9"/>
  <!-- Left penalty box -->
  <rect x="150" y="248" width="110" height="204" fill="none" stroke="#c9a227" stroke-width="2" opacity="0.8"/>
  <!-- Left goal box -->
  <rect x="150" y="296" width="50" height="108" fill="none" stroke="#c9a227" stroke-width="1.5" opacity="0.8"/>
  <!-- Left goal -->
  <rect x="130" y="316" width="20" height="68" fill="none" stroke="#e8c84a" stroke-width="2.5" opacity="0.9"/>
  <!-- Right penalty box -->
  <rect x="940" y="248" width="110" height="204" fill="none" stroke="#c9a227" stroke-width="2" opacity="0.8"/>
  <!-- Right goal box -->
  <rect x="1000" y="296" width="50" height="108" fill="none" stroke="#c9a227" stroke-width="1.5" opacity="0.8"/>
  <!-- Right goal -->
  <rect x="1050" y="316" width="20" height="68" fill="none" stroke="#e8c84a" stroke-width="2.5" opacity="0.9"/>
  <!-- Left penalty arc -->
  <path d="M 260 290 Q 310 350 260 410" fill="none" stroke="#c9a227" stroke-width="2" opacity="0.7"/>
  <!-- Right penalty arc -->
  <path d="M 940 290 Q 890 350 940 410" fill="none" stroke="#c9a227" stroke-width="2" opacity="0.7"/>
  <!-- Corner arcs -->
  <path d="M 150 175 Q 165 158 180 158" fill="none" stroke="#c9a227" stroke-width="1.5" opacity="0.7"/>
  <path d="M 150 525 Q 165 542 180 542" fill="none" stroke="#c9a227" stroke-width="1.5" opacity="0.7"/>
  <path d="M 1050 158 Q 1035 158 1035 175" fill="none" stroke="#c9a227" stroke-width="1.5" opacity="0.7"/>
  <path d="M 1050 542 Q 1035 542 1035 525" fill="none" stroke="#c9a227" stroke-width="1.5" opacity="0.7"/>
  <!-- Field shadow/depth overlay -->
  <rect x="120" y="130" width="960" height="440" rx="8" fill="url(#skyGrad)" opacity="0.15"/>
  <!-- Subtle gold glow on lines -->
  <rect x="150" y="158" width="900" height="384" rx="4" fill="none" stroke="#e8c84a" stroke-width="0.5" opacity="0.3" filter="url(#blur1)"/>
</svg>`)}`;

// Knight Easter Egg Component
const KnightEasterEgg = ({ onDone }) => {
  useEffect(() => {
    const t = setTimeout(onDone, 3200);
    return () => clearTimeout(t);
  }, [onDone]);

  return (
    <div style={{ position:"fixed", bottom:"80px", left:0, right:0, zIndex:999, pointerEvents:"none", overflow:"hidden", height:"160px" }}>
      <div style={{ animation:"knightRide 3.2s linear forwards", display:"inline-block", position:"absolute", bottom:0 }}>
        <svg width="160" height="140" viewBox="0 0 160 140" xmlns="http://www.w3.org/2000/svg">
          {/* Horse body */}
          <ellipse cx="80" cy="95" rx="48" ry="26" fill="#8B5E3C"/>
          {/* Horse neck */}
          <ellipse cx="110" cy="72" rx="14" ry="22" fill="#8B5E3C" transform="rotate(-20 110 72)"/>
          {/* Horse head */}
          <ellipse cx="124" cy="55" rx="16" ry="11" fill="#8B5E3C" transform="rotate(-10 124 55)"/>
          {/* Horse ear */}
          <polygon points="130,44 134,36 138,44" fill="#7a5230"/>
          {/* Horse eye */}
          <circle cx="130" cy="52" r="2.5" fill="#1a1a1a"/>
          <circle cx="131" cy="51" r="0.8" fill="white"/>
          {/* Horse nostril */}
          <ellipse cx="136" cy="58" rx="2" ry="1.5" fill="#7a5230"/>
          {/* Horse mane */}
          <path d="M108 52 Q112 45 116 50 Q118 42 122 48 Q124 40 128 46" fill="none" stroke="#4a3020" stroke-width="3" stroke-linecap="round"/>
          {/* Horse tail */}
          <path d="M32 88 Q18 78 15 90 Q12 102 22 98" fill="none" stroke="#4a3020" stroke-width="4" stroke-linecap="round"/>
          <path d="M32 92 Q14 85 10 98" fill="none" stroke="#4a3020" stroke-width="3" stroke-linecap="round"/>
          {/* Saddle */}
          <ellipse cx="78" cy="74" rx="22" ry="8" fill="#1B2A5E"/>
          <ellipse cx="78" cy="72" rx="22" ry="6" fill="#2d4090"/>
          {/* Saddle gold trim */}
          <ellipse cx="78" cy="72" rx="22" ry="6" fill="none" stroke="#C9A227" stroke-width="1.5"/>
          {/* Front legs - galloping */}
          <line x1="100" y1="112" x2="115" y2="132" stroke="#7a5230" stroke-width="5" stroke-linecap="round"/>
          <line x1="115" y1="132" x2="122" y2="128" stroke="#7a5230" stroke-width="5" stroke-linecap="round"/>
          <line x1="90" y1="115" x2="98" y2="138" stroke="#8B5E3C" stroke-width="5" stroke-linecap="round"/>
          {/* Back legs */}
          <line x1="58" y1="112" x2="45" y2="135" stroke="#7a5230" stroke-width="5" stroke-linecap="round"/>
          <line x1="45" y1="135" x2="38" y2="130" stroke="#7a5230" stroke-width="5" stroke-linecap="round"/>
          <line x1="68" y1="116" x2="62" y2="138" stroke="#8B5E3C" stroke-width="5" stroke-linecap="round"/>
          {/* Hooves */}
          <ellipse cx="122" cy="128" rx="5" ry="3" fill="#2a2a2a"/>
          <ellipse cx="38" cy="130" rx="5" ry="3" fill="#2a2a2a"/>
          <ellipse cx="98" cy="138" rx="5" ry="3" fill="#2a2a2a"/>
          <ellipse cx="62" cy="138" rx="5" ry="3" fill="#2a2a2a"/>
          {/* Knight body - navy tabard */}
          <rect x="64" y="48" width="26" height="28" rx="3" fill="#1B2A5E"/>
          {/* Gold cross on tabard */}
          <rect x="75" y="50" width="4" height="14" fill="#C9A227"/>
          <rect x="69" y="56" width="16" height="4" fill="#C9A227"/>
          {/* Knight arms */}
          <rect x="58" y="50" width="8" height="18" rx="3" fill="#888" transform="rotate(15 62 50)"/>
          <rect x="88" y="48" width="8" height="18" rx="3" fill="#888" transform="rotate(-20 92 48)"/>
          {/* Lance */}
          <line x1="96" y1="45" x2="148" y2="20" stroke="#8B5E3C" stroke-width="3" stroke-linecap="round"/>
          {/* Lance pennant */}
          <polygon points="148,20 138,24 140,16" fill="#C9A227"/>
          {/* Helmet */}
          <ellipse cx="77" cy="44" rx="14" ry="13" fill="#aaa"/>
          {/* Helmet visor */}
          <rect x="66" y="44" width="22" height="7" rx="2" fill="#888"/>
          <line x1="66" y1="47" x2="88" y2="47" stroke="#666" stroke-width="1"/>
          {/* Helmet plume */}
          <path d="M77 31 Q72 22 68 26 Q73 18 77 22 Q81 18 86 26 Q82 22 77 31" fill="#C9A227"/>
          {/* Shield */}
          <path d="M58 52 L50 52 L50 65 L54 70 L58 65 Z" fill="#1B2A5E" stroke="#C9A227" stroke-width="1.5"/>
          <circle cx="54" cy="60" r="4" fill="#C9A227" opacity="0.8"/>
          {/* Dust clouds */}
          <circle cx="30" cy="130" r="8" fill="rgba(201,162,39,0.15)"/>
          <circle cx="18" cy="126" r="6" fill="rgba(201,162,39,0.1)"/>
          <circle cx="42" cy="133" r="5" fill="rgba(201,162,39,0.12)"/>
        </svg>
      </div>
      <style>{`
        @keyframes knightRide {
          0%   { left: -180px; transform: scaleX(1); }
          48%  { left: calc(100% + 20px); transform: scaleX(1); }
          50%  { left: calc(100% + 20px); transform: scaleX(-1); }
          98%  { left: -180px; transform: scaleX(-1); }
          100% { left: -180px; transform: scaleX(-1); opacity:0; }
        }
      `}</style>
    </div>
  );
};


const PASSWORD = "browns";

const PX_PER_MIN = 1.25;
const START_HOUR = 7;
const END_HOUR = 20;
const TOTAL_MINS = (END_HOUR - START_HOUR) * 60;
const TOTAL_HEIGHT = TOTAL_MINS * PX_PER_MIN;

const DAYS = ["Monday","Tuesday","Wednesday","Thursday","Friday","Saturday","Sunday"];

const BLOCKED_HOURS = {
  Monday:[], Tuesday:[], Wednesday:[],
  Thursday:[], Friday:[], Saturday:[], Sunday:[],
};

const SPORT_COLORS = {
  Soccer:   { bg:"#1B2A5E", text:"#E8C84A", border:"#2d4090" },
  Football: { bg:"#0A1B2A", text:"#E8C84A", border:"#103a5a" },
  Lacrosse: { bg:"#2a1a3a", text:"#d0a0ff", border:"#5a2a8a" },
  Other:    { bg:"#1a1a2a", text:"#C9A227", border:"#3a3a6a" },
};

const DURATION_OPTIONS = [
  { label:"30 min", value:30 },
  { label:"1 hour", value:60 },
  { label:"1½ hours", value:90 },
];

const allStartMins = [];
for (let h = START_HOUR; h < END_HOUR; h++)
  for (let m = 0; m < 60; m += 15)
    allStartMins.push(h * 60 + m);

const formatMin = (totalMin) => {
  const h = Math.floor(totalMin / 60);
  const m = totalMin % 60;
  const ampm = h < 12 ? "AM" : "PM";
  const h12 = h === 0 ? 12 : h > 12 ? h - 12 : h === 12 ? 12 : h;
  return `${h12}:${m.toString().padStart(2,"0")} ${ampm}`;
};

const minToY = (min) => (min - START_HOUR * 60) * PX_PER_MIN;

const isBlockedRange = (day, startMin, durationMin) => {
  const blocked = BLOCKED_HOURS[day] || [];
  for (let m = startMin; m < startMin + durationMin; m++) {
    const hr = Math.floor(m / 60);
    if (blocked.includes(hr)) return true;
  }
  return false;
};

// ── Date helpers ──────────────────────────────────────────────────────
const getWeekStart = (weekOffset) => {
  const now = new Date();
  const day = now.getDay();
  const monday = new Date(now);
  monday.setDate(now.getDate() - (day === 0 ? 6 : day - 1) + weekOffset * 7);
  monday.setHours(0,0,0,0);
  return monday;
};

const MONTHS = ["January","February","March","April","May","June","July","August","September","October","November","December"];
const MONTHS_SHORT = ["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"];

const getDayDate = (weekOffset, dayIndex) => {
  const start = getWeekStart(weekOffset);
  const d = new Date(start);
  d.setDate(start.getDate() + dayIndex);
  return d;
};

const getWeekMonthLabel = (weekOffset) => {
  const start = getWeekStart(weekOffset);
  const end = new Date(start);
  end.setDate(start.getDate() + 6);
  if (start.getMonth() === end.getMonth()) {
    return `${MONTHS[start.getMonth()]} ${start.getFullYear()}`;
  }
  return `${MONTHS_SHORT[start.getMonth()]} – ${MONTHS_SHORT[end.getMonth()]} ${end.getFullYear()}`;
};
// ─────────────────────────────────────────────────────────────────────

// Supabase replaces localStorage

export default function App() {
  const [authed, setAuthed] = useState(false);
  const [pwInput, setPwInput] = useState("");
  const [pwError, setPwError] = useState(false);
  const [shaking, setShaking] = useState(false);
  const [bookings, setBookings] = useState([]);
  const [modal, setModal] = useState(null);
  const [form, setForm] = useState({ coach:"", sport:"Soccer", note:"", grade:"K", startMin:0, duration:60 });
  const [viewBooking, setViewBooking] = useState(null);
  const [conflict, setConflict] = useState(false);
  const [showKnight, setShowKnight] = useState(false);
  const [activeWeek, setActiveWeek] = useState(0);
  const gridRef = useRef(null);

  // Load from Supabase on login
  useEffect(() => {
    if (authed) {
      const load = async () => {
        try {
          const { data, error } = await supabase
            .from("bookings")
            .select("*");
          if (!error && data) setBookings(data);
        } catch {}
      };
      load();
    }
  }, [authed]);



  const handleLogin = () => {
    if (pwInput === PASSWORD) {
      setAuthed(true);
    } else {
      setPwError(true); setShaking(true);
      setTimeout(() => setShaking(false), 500);
      setTimeout(() => setPwError(false), 2500);
      setPwInput("");
    }
  };

  const weekBookings = bookings.filter(b => b.week === activeWeek);
  const weekLabel = activeWeek === 0 ? "This Week" : activeWeek === 1 ? "Next Week" : `Week +${activeWeek}`;

  const hasConflict = (day, startMin, durationMin, excludeId) => {
    return weekBookings.some(b => {
      if (b.day !== day || b.id === excludeId) return false;
      const bEnd = b.startMin + b.duration;
      const newEnd = startMin + durationMin;
      return startMin < bEnd && newEnd > b.startMin;
    });
  };

  const handleColumnClick = (e, day) => {
    if (e.target !== e.currentTarget && !e.target.classList.contains("grid-bg")) return;
    const rect = e.currentTarget.getBoundingClientRect();
    const clickedRelY = e.clientY - rect.top;
    const rawMin = START_HOUR * 60 + clickedRelY / PX_PER_MIN;
    const snapped = Math.round(rawMin / 15) * 15;
    const clamped = Math.max(START_HOUR * 60, Math.min(END_HOUR * 60 - 30, snapped));
    setConflict(false);
    setModal({ day });
    setForm({ coach:"", sport:"Soccer", note:"", grade:"K", startMin:clamped, duration:60 });
  };

  const confirmBooking = async () => {
    if (!form.coach.trim()) return;
    if (isBlockedRange(modal.day, form.startMin, form.duration)) return;
    if (hasConflict(modal.day, form.startMin, form.duration, null)) {
      setConflict(true);
      return;
    }
    const id = Date.now().toString();
    const newBooking = { id, week:activeWeek, day:modal.day, ...form };
    try {
      const { error } = await supabase.from("bookings").insert([newBooking]);
      if (!error) {
        setBookings(prev => [...prev, newBooking]);
        setModal(null);
        setConflict(false);
        setShowKnight(true);
      }
    } catch {}
  };

  const deleteBooking = async (id) => {
    try {
      const { error } = await supabase.from("bookings").delete().eq("id", id);
      if (!error) {
        setBookings(prev => prev.filter(b => b.id !== id));
        setViewBooking(null);
      }
    } catch {}
  };

  const inputStyle = {
    width:"100%", boxSizing:"border-box",
    background:"rgba(249,245,237,0.06)",
    border:"1px solid rgba(201,162,39,0.35)",
    borderRadius:"4px", padding:"9px 12px",
    fontSize:"15px", color:"#F9F5ED",
    outline:"none", fontFamily:"'Cormorant Garamond', Georgia, serif",
    marginBottom:"14px", transition:"border-color 0.2s",
  };

  const labelStyle = {
    display:"block", fontSize:"11px", fontWeight:600,
    color:"#C9A227", marginBottom:"5px",
    textTransform:"uppercase", letterSpacing:"1.5px",
    fontFamily:"'Cormorant SC', Georgia, serif",
  };

  // ── Login screen ───────────────────────────────────────────────────
  if (!authed) return (
    <div style={{ minHeight:"100vh", display:"flex", alignItems:"center", justifyContent:"center", fontFamily:"'Cormorant Garamond', Georgia, serif", position:"relative", overflow:"hidden" }}>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Cormorant+Garamond:ital,wght@0,400;0,500;0,600;0,700;1,400;1,600&family=Cormorant+SC:wght@400;500;600;700&display=swap');
        @keyframes shake{0%,100%{transform:translateX(0)}20%{transform:translateX(-8px)}40%{transform:translateX(8px)}60%{transform:translateX(-5px)}80%{transform:translateX(5px)}}
        @keyframes fadeUp{from{opacity:0;transform:translateY(16px)}to{opacity:1;transform:translateY(0)}}
        *{box-sizing:border-box;margin:0;padding:0}
      `}</style>
      <div style={{ position:"absolute",inset:0,backgroundImage:`url(${FIELD_SVG})`,backgroundSize:"cover",backgroundPosition:"center",filter:"brightness(0.28) saturate(0.5)" }} />
      <div style={{ position:"absolute",inset:0,background:"linear-gradient(160deg,rgba(14,20,54,0.75),rgba(27,42,94,0.55))" }} />
      <div style={{ position:"absolute",top:0,left:0,right:0,height:"3px",background:"linear-gradient(90deg,transparent,#C9A227,#E8C84A,#C9A227,transparent)" }} />

      <div style={{ position:"relative",zIndex:2,background:"rgba(10,14,40,0.93)",border:"1px solid rgba(201,162,39,0.3)",borderRadius:"6px",padding:"40px 28px",width:"min(360px, 92vw)",boxShadow:"0 40px 100px rgba(0,0,0,0.7)",backdropFilter:"blur(24px)",textAlign:"center",animation:shaking?"shake 0.4s ease-in-out":"fadeUp 0.65s ease-out" }}>
        <div style={{ width:"80px",height:"48px",borderRadius:"3px",overflow:"hidden",margin:"0 auto 22px",border:"1px solid rgba(201,162,39,0.4)",boxShadow:"0 4px 20px rgba(0,0,0,0.5)" }}>
          <img src={FIELD_SVG} style={{ width:"100%",height:"100%",objectFit:"cover",objectPosition:"center 30%" }} alt="field" />
        </div>
        <div style={{ height:"1px",background:"linear-gradient(90deg,transparent,rgba(201,162,39,0.5),transparent)",marginBottom:"22px" }} />
        <h1 style={{ margin:"0 0 28px",fontSize:"32px",fontWeight:600,color:"#F9F5ED",letterSpacing:"-0.5px" }}>Brown's Field</h1>
        <input
          type="password" placeholder="Enter access password" value={pwInput}
          onChange={e => setPwInput(e.target.value)}
          onKeyDown={e => e.key === "Enter" && handleLogin()}
          style={{ ...inputStyle, borderColor:pwError?"rgba(220,80,80,0.7)":"rgba(201,162,39,0.35)", marginBottom:pwError?"6px":"12px" }}
        />
        {pwError && <p style={{ color:"#e07070",fontSize:"13px",margin:"0 0 12px",fontStyle:"italic" }}>Incorrect password. Please try again.</p>}
        <button onClick={handleLogin} style={{ width:"100%",padding:"13px",border:"1px solid rgba(201,162,39,0.5)",borderRadius:"4px",background:"linear-gradient(135deg,#C9A227,#a07c18)",color:"#0a0e28",fontSize:"14px",fontWeight:700,cursor:"pointer",letterSpacing:"2px",textTransform:"uppercase",fontFamily:"'Cormorant SC',Georgia,serif",boxShadow:"0 4px 24px rgba(201,162,39,0.25)",transition:"opacity 0.2s,transform 0.1s" }}
          onMouseOver={e=>{e.currentTarget.style.opacity="0.88";e.currentTarget.style.transform="translateY(-1px)"}}
          onMouseOut={e=>{e.currentTarget.style.opacity="1";e.currentTarget.style.transform="translateY(0)"}}>
          Access Scheduler
        </button>
        <div style={{ height:"1px",background:"linear-gradient(90deg,transparent,rgba(201,162,39,0.3),transparent)",marginTop:"28px" }} />
        <p style={{ margin:"14px 0 0",fontSize:"11px",color:"rgba(249,245,237,0.22)",letterSpacing:"0.5px" }}>Coram Deo</p>
      </div>
    </div>
  );

  // ── Main scheduler ─────────────────────────────────────────────────
  return (
    <div style={{ minHeight:"100vh",fontFamily:"'Cormorant Garamond',Georgia,serif",position:"relative" }}>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Cormorant+Garamond:ital,wght@0,400;0,500;0,600;0,700;1,400;1,600&family=Cormorant+SC:wght@400;500;600;700&display=swap');
        @keyframes fadeIn{from{opacity:0;transform:scale(0.97)}to{opacity:1;transform:scale(1)}}
        *::-webkit-scrollbar{height:5px;width:5px}
        *::-webkit-scrollbar-track{background:transparent}
        *::-webkit-scrollbar-thumb{background:rgba(201,162,39,0.25);border-radius:3px}
        .day-col:hover .hover-hint{opacity:1!important}
        .legend-bar{display:flex}
        @media(max-width:600px){
          .legend-bar{display:none!important}
          .week-hint{display:none!important}
        }
      `}</style>

      <div style={{ position:"fixed",inset:0,zIndex:0,backgroundImage:`url(${FIELD_SVG})`,backgroundSize:"cover",backgroundPosition:"center top",filter:"brightness(0.2) saturate(0.4)" }} />
      <div style={{ position:"fixed",inset:0,zIndex:0,background:"linear-gradient(180deg,rgba(10,14,48,0.85),rgba(18,24,64,0.78))" }} />
      <div style={{ position:"fixed",top:0,left:0,right:0,height:"3px",zIndex:10,background:"linear-gradient(90deg,transparent,#C9A227,#E8C84A,#C9A227,transparent)" }} />

      <div style={{ position:"relative",zIndex:1 }}>
        {/* Header */}
        <div style={{ background:"rgba(8,12,36,0.9)",backdropFilter:"blur(20px)",borderBottom:"1px solid rgba(201,162,39,0.2)",color:"#F9F5ED",padding:"0 10px",display:"flex",alignItems:"center",justifyContent:"space-between",height:"50px" }}>
          <div style={{ display:"flex",alignItems:"center",gap:"14px" }}>
            <div style={{ width:"40px",height:"25px",borderRadius:"3px",overflow:"hidden",border:"1px solid rgba(201,162,39,0.4)" }}>
              <img src={FIELD_SVG} style={{ width:"100%",height:"100%",objectFit:"cover",objectPosition:"center 30%" }} alt="" />
            </div>
            <div style={{ fontSize:"22px",fontWeight:600,color:"#F9F5ED",letterSpacing:"0.3px" }}>Brown's Field</div>
          </div>
          <button onClick={() => setAuthed(false)} style={{ background:"transparent",border:"1px solid rgba(201,162,39,0.3)",borderRadius:"3px",padding:"5px 14px",color:"rgba(249,245,237,0.65)",fontSize:"12px",cursor:"pointer",fontFamily:"'Cormorant SC',Georgia,serif",letterSpacing:"1px",transition:"all 0.2s" }}
            onMouseOver={e=>{e.currentTarget.style.borderColor="#C9A227";e.currentTarget.style.color="#C9A227"}}
            onMouseOut={e=>{e.currentTarget.style.borderColor="rgba(201,162,39,0.3)";e.currentTarget.style.color="rgba(249,245,237,0.65)"}}>
            Sign Out
          </button>
        </div>

        {/* Week nav + legend */}
        <div style={{ background:"rgba(8,12,36,0.78)",backdropFilter:"blur(12px)",borderBottom:"1px solid rgba(201,162,39,0.12)",padding:"6px 12px",display:"flex",alignItems:"center",gap:"8px",flexWrap:"wrap",minHeight:"46px" }}>
          <button onClick={() => setActiveWeek(w => Math.max(0,w-1))} disabled={activeWeek===0} style={{ background:"transparent",border:"1px solid rgba(201,162,39,0.25)",borderRadius:"3px",padding:"3px 10px",cursor:activeWeek===0?"not-allowed":"pointer",opacity:activeWeek===0?0.3:1,color:"#C9A227",fontFamily:"'Cormorant Garamond',Georgia,serif",fontSize:"13px" }}>← Prev</button>
          <div style={{ textAlign:"center",minWidth:"160px" }}>
            <div style={{ fontWeight:700,color:"#F9F5ED",fontSize:"15px",fontFamily:"'Cormorant SC',Georgia,serif",letterSpacing:"1px" }}>{getWeekMonthLabel(activeWeek)}</div>
            <div style={{ fontSize:"10px",color:"rgba(201,162,39,0.5)",letterSpacing:"0.5px",marginTop:"1px" }}>{weekLabel}</div>
          </div>
          <button onClick={() => setActiveWeek(w => Math.min(8,w+1))} style={{ background:"transparent",border:"1px solid rgba(201,162,39,0.25)",borderRadius:"3px",padding:"3px 10px",cursor:"pointer",color:"#C9A227",fontFamily:"'Cormorant Garamond',Georgia,serif",fontSize:"13px" }}>Next →</button>
          <div style={{ width:"1px",height:"22px",background:"rgba(201,162,39,0.2)",margin:"0 4px" }} />
          <div className="legend-bar" style={{ display:"flex",gap:"5px",alignItems:"center" }}>
            {Object.entries(SPORT_COLORS).map(([s,c]) => (
              <span key={s} style={{ fontSize:"10px",padding:"2px 7px",borderRadius:"3px",background:c.bg,color:c.text,border:`1px solid ${c.border}`,fontFamily:"'Cormorant SC',Georgia,serif",letterSpacing:"0.5px" }}>{s}</span>
            ))}
            <span style={{ fontSize:"10px",padding:"2px 7px",borderRadius:"3px",background:"rgba(15,15,25,0.9)",color:"rgba(249,245,237,0.25)",border:"1px solid rgba(50,50,70,0.6)",fontFamily:"'Cormorant SC',Georgia,serif" }}>Unavailable</span>
          </div>
          <div className="week-hint" style={{ marginLeft:"auto",fontSize:"11px",color:"rgba(201,162,39,0.45)",fontStyle:"italic" }}>Click any open slot to book</div>
        </div>

        {/* Scheduler grid */}
        <div ref={gridRef} style={{ overflowX:"auto",padding:"8px 6px 24px",WebkitOverflowScrolling:"touch" }}>
          <div style={{ minWidth:"100%" }}>
            {/* Day headers with dates */}
            <div style={{ display:"grid",gridTemplateColumns:"30px repeat(7,1fr)",gap:"2px",marginBottom:"2px" }}>
              <div />
              {DAYS.map((d,i) => {
                const date = getDayDate(activeWeek, i);
                const isToday = new Date().toDateString() === date.toDateString();
                return (
                  <div key={d} style={{ textAlign:"center",padding:"6px 2px 5px",background:isToday?"rgba(201,162,39,0.12)":"rgba(8,12,40,0.88)",backdropFilter:"blur(8px)",borderRadius:"4px 4px 0 0",border:`1px solid ${isToday?"rgba(201,162,39,0.45)":"rgba(201,162,39,0.18)"}`,borderBottom:"none" }}>
                    <div style={{ fontSize:"9px",fontWeight:700,color:isToday?"#E8C84A":"#C9A227",letterSpacing:"0.5px",textTransform:"uppercase",fontFamily:"'Cormorant SC',Georgia,serif" }}>{d.slice(0,3)}</div>
                    <div style={{ fontSize:"13px",fontWeight:600,color:isToday?"#F9F5ED":"rgba(249,245,237,0.75)",fontFamily:"'Cormorant Garamond',Georgia,serif",lineHeight:1.2,marginTop:"1px" }}>{date.getMonth()+1}/{date.getDate()}</div>
                  </div>
                );
              })}
            </div>

            {/* Time grid */}
            <div style={{ display:"grid",gridTemplateColumns:"30px repeat(7,1fr)",gap:"2px" }}>
              {/* Time labels */}
              <div style={{ position:"relative",height:`${TOTAL_HEIGHT}px`,minWidth:"30px" }}>
                {Array.from({length:(END_HOUR-START_HOUR)+1},(_,i) => i+START_HOUR).map(h => (
                  <div key={h} style={{ position:"absolute",top:`${(h-START_HOUR)*60*PX_PER_MIN - 8}px`,right:"2px",fontSize:"10px",fontWeight:700,color:"rgba(255,255,255,0.9)",whiteSpace:"nowrap",fontFamily:"'Cormorant SC',Georgia,serif",letterSpacing:"0.3px",textShadow:"0 1px 4px rgba(0,0,0,0.8)" }}>
                    {h===12?"12 PM":h<12?`${h} AM`:`${h-12} PM`}
                  </div>
                ))}
              </div>

              {/* Day columns */}
              {DAYS.map(day => {
                const dayBookings = weekBookings.filter(b => b.day === day);
                const blockedHrs = BLOCKED_HOURS[day] || [];
                return (
                  <div key={day} className="day-col" onClick={e => handleColumnClick(e, day)}
                    style={{ position:"relative",height:`${TOTAL_HEIGHT}px`,background:"rgba(8,12,40,0.5)",backdropFilter:"blur(4px)",border:"1px solid rgba(201,162,39,0.1)",borderRadius:"0 0 4px 4px",cursor:"crosshair",overflow:"hidden" }}>

                    {/* Hour grid lines */}
                    {Array.from({length:END_HOUR-START_HOUR+1},(_,i) => i).map(i => (
                      <div key={i} style={{ position:"absolute",top:`${i*60*PX_PER_MIN}px`,left:0,right:0,height:"1px",background:i%2===0?"rgba(201,162,39,0.12)":"rgba(201,162,39,0.05)",pointerEvents:"none" }} />
                    ))}
                    {Array.from({length:END_HOUR-START_HOUR},(_,i) => i).map(i => (
                      <div key={`h${i}`} style={{ position:"absolute",top:`${(i*60+30)*PX_PER_MIN}px`,left:0,right:0,height:"1px",background:"rgba(201,162,39,0.04)",pointerEvents:"none" }} />
                    ))}

                    {/* Blocked ranges */}
                    {blockedHrs.map(h => (
                      <div key={h} style={{ position:"absolute",top:`${(h-START_HOUR)*60*PX_PER_MIN}px`,height:`${60*PX_PER_MIN}px`,left:0,right:0,background:"repeating-linear-gradient(45deg,rgba(18,18,30,0.95),rgba(18,18,30,0.95) 5px,rgba(12,12,22,0.95) 5px,rgba(12,12,22,0.95) 10px)",display:"flex",alignItems:"center",justifyContent:"center",pointerEvents:"none",borderBottom:"1px solid rgba(50,50,70,0.4)" }}>
                        <span style={{ fontSize:"9px",color:"rgba(201,162,39,0.2)",letterSpacing:"1px",fontFamily:"'Cormorant SC',Georgia,serif" }}>UNAVAIL.</span>
                      </div>
                    ))}

                    {/* Bookings */}
                    {dayBookings.map(b => {
                      const colors = SPORT_COLORS[b.sport] || SPORT_COLORS.Other;
                      const top = minToY(b.startMin);
                      const height = b.duration * PX_PER_MIN;
                      return (
                        <div key={b.id} onClick={e => { e.stopPropagation(); setViewBooking(b); }}
                          style={{ position:"absolute",top:`${top}px`,height:`${height}px`,left:"2px",right:"2px",background:"#ffffff",border:`2px solid ${colors.border}`,borderRadius:"4px",padding:"3px 5px",cursor:"pointer",boxShadow:"0 2px 10px rgba(0,0,0,0.5)",overflow:"hidden",zIndex:2,transition:"filter 0.1s",borderLeft:`4px solid ${colors.border}` }}
                          onMouseOver={e => e.currentTarget.style.filter="brightness(0.93)"}
                          onMouseOut={e => e.currentTarget.style.filter="none"}>
                          <div style={{ fontSize:"11px",fontWeight:800,color:"#0a0e28",lineHeight:1.2,fontFamily:"'Cormorant SC',Georgia,serif",letterSpacing:"0.3px",overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap" }}>{b.coach}</div>
                          {height > 28 && <div style={{ fontSize:"10px",color:"#333",fontStyle:"italic",fontFamily:"'Cormorant Garamond',Georgia,serif" }}>{b.sport} · {b.duration<60?`${b.duration}m`:b.duration===60?"1 hr":"1.5 hr"}</div>}
                        </div>
                      );
                    })}

                    <div className="hover-hint" style={{ position:"absolute",inset:0,display:"flex",alignItems:"center",justifyContent:"center",pointerEvents:"none",opacity:0,transition:"opacity 0.2s" }}>
                      <span style={{ fontSize:"22px",color:"rgba(201,162,39,0.18)" }}>+</span>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>

      {/* Book Modal */}
      {modal && (
        <div style={{ position:"fixed",inset:0,background:"rgba(0,0,0,0.65)",display:"flex",alignItems:"center",justifyContent:"center",zIndex:200,backdropFilter:"blur(6px)" }} onClick={() => { setModal(null); setConflict(false); }}>
          <div style={{ background:"rgba(8,12,40,0.97)",border:"1px solid rgba(201,162,39,0.3)",borderRadius:"6px",padding:"24px 20px 20px",width:"min(400px, 94vw)",boxShadow:"0 40px 100px rgba(0,0,0,0.6)",animation:"fadeIn 0.2s ease-out",color:"#F9F5ED",maxHeight:"90vh",overflowY:"auto" }} onClick={e => e.stopPropagation()}>
            <div style={{ height:"2px",background:"linear-gradient(90deg,transparent,#C9A227,transparent)",marginBottom:"22px" }} />
            <h2 style={{ margin:"0 0 4px",fontSize:"22px",fontWeight:600 }}>Reserve Time Slot</h2>
            <p style={{ margin:"0 0 22px",fontSize:"13px",color:"rgba(249,245,237,0.4)",fontStyle:"italic" }}>{modal.day}</p>

            <label style={labelStyle}>Start Time</label>
            <select value={form.startMin} onChange={e => { setConflict(false); setForm(f => ({...f,startMin:parseInt(e.target.value)})); }} style={{ ...inputStyle,cursor:"pointer" }}>
              {allStartMins.map(m => <option key={m} value={m} style={{ background:"#080c28" }}>{formatMin(m)}</option>)}
            </select>

            <label style={labelStyle}>Duration</label>
            <div style={{ display:"flex",gap:"8px",marginBottom:"14px" }}>
              {DURATION_OPTIONS.map(opt => (
                <button key={opt.value} onClick={() => { setConflict(false); setForm(f => ({...f,duration:opt.value})); }}
                  style={{ flex:1,padding:"9px 6px",borderRadius:"4px",cursor:"pointer",border:`1px solid ${form.duration===opt.value?"#C9A227":"rgba(201,162,39,0.25)"}`,background:form.duration===opt.value?"rgba(201,162,39,0.15)":"transparent",color:form.duration===opt.value?"#E8C84A":"rgba(249,245,237,0.5)",fontSize:"13px",fontFamily:"'Cormorant Garamond',Georgia,serif",fontWeight:form.duration===opt.value?600:400,transition:"all 0.15s" }}>
                  {opt.label}
                </button>
              ))}
            </div>

            <div style={{ background:"rgba(201,162,39,0.06)",border:"1px solid rgba(201,162,39,0.15)",borderRadius:"4px",padding:"8px 12px",marginBottom:"16px",fontSize:"13px",color:"rgba(249,245,237,0.55)",fontStyle:"italic",textAlign:"center" }}>
              {formatMin(form.startMin)} — {formatMin(form.startMin + form.duration)}
            </div>

            <label style={labelStyle}>Coach Name *</label>
            <input value={form.coach} onChange={e => setForm(f => ({...f,coach:e.target.value}))} placeholder="Enter coach name" style={inputStyle}
              onFocus={e => e.target.style.borderColor="#C9A227"} onBlur={e => e.target.style.borderColor="rgba(201,162,39,0.35)"} />

            <label style={labelStyle}>Grade</label>
            <select value={form.grade} onChange={e => setForm(f => ({...f,grade:e.target.value}))} style={{ ...inputStyle,cursor:"pointer" }}>
              {["K","1st","2nd","3rd","4th","5th","6th","7th","8th","9th","10th","11th","12th"].map(g => <option key={g} style={{ background:"#080c28" }}>{g}</option>)}
            </select>

            <label style={labelStyle}>Sport / Activity</label>
            <select value={form.sport} onChange={e => setForm(f => ({...f,sport:e.target.value}))} style={{ ...inputStyle,cursor:"pointer" }}>
              {Object.keys(SPORT_COLORS).map(s => <option key={s} style={{ background:"#080c28" }}>{s}</option>)}
            </select>

            <label style={labelStyle}>Notes (optional)</label>
            <textarea value={form.note} onChange={e => setForm(f => ({...f,note:e.target.value}))} placeholder="e.g. Team size, equipment needs…" rows={2} style={{ ...inputStyle,resize:"none",marginBottom:"20px" }} />

            {conflict && <p style={{ color:"#e07070",fontSize:"13px",marginBottom:"12px",fontStyle:"italic",textAlign:"center" }}>⚠ This time conflicts with an existing booking.</p>}
            {isBlockedRange(modal.day, form.startMin, form.duration) && <p style={{ color:"#e07070",fontSize:"13px",marginBottom:"12px",fontStyle:"italic",textAlign:"center" }}>⚠ This time slot is unavailable.</p>}

            <div style={{ height:"1px",background:"rgba(201,162,39,0.15)",marginBottom:"18px" }} />
            <div style={{ display:"flex",gap:"10px" }}>
              <button onClick={() => { setModal(null); setConflict(false); }} style={{ flex:1,padding:"11px",border:"1px solid rgba(201,162,39,0.2)",borderRadius:"4px",background:"transparent",color:"rgba(249,245,237,0.55)",cursor:"pointer",fontSize:"13px",fontFamily:"'Cormorant SC',Georgia,serif",letterSpacing:"1px" }}>Cancel</button>
              <button onClick={confirmBooking} disabled={!form.coach.trim() || isBlockedRange(modal.day, form.startMin, form.duration)}
                style={{ flex:2,padding:"11px",border:"none",borderRadius:"4px",background:(form.coach.trim()&&!isBlockedRange(modal.day,form.startMin,form.duration))?"linear-gradient(135deg,#C9A227,#a07c18)":"rgba(201,162,39,0.1)",color:(form.coach.trim()&&!isBlockedRange(modal.day,form.startMin,form.duration))?"#0a0e28":"rgba(201,162,39,0.25)",cursor:(form.coach.trim()&&!isBlockedRange(modal.day,form.startMin,form.duration))?"pointer":"not-allowed",fontSize:"13px",fontWeight:700,fontFamily:"'Cormorant SC',Georgia,serif",letterSpacing:"2px",textTransform:"uppercase" }}>
                Confirm Booking
              </button>
            </div>
          </div>
        </div>
      )}

      {/* View Booking Modal */}
      {viewBooking && (
        <div style={{ position:"fixed",inset:0,background:"rgba(0,0,0,0.65)",display:"flex",alignItems:"center",justifyContent:"center",zIndex:200,backdropFilter:"blur(6px)" }} onClick={() => setViewBooking(null)}>
          <div style={{ background:"rgba(8,12,40,0.97)",border:"1px solid rgba(201,162,39,0.3)",borderRadius:"6px",padding:"24px 20px",width:"min(340px, 94vw)",boxShadow:"0 40px 100px rgba(0,0,0,0.6)",animation:"fadeIn 0.2s ease-out",color:"#F9F5ED" }} onClick={e => e.stopPropagation()}>
            <div style={{ height:"2px",background:"linear-gradient(90deg,transparent,#C9A227,transparent)",marginBottom:"18px" }} />
            <div style={{ display:"inline-block",padding:"3px 10px",borderRadius:"3px",marginBottom:"12px",background:(SPORT_COLORS[viewBooking.sport]||SPORT_COLORS.Other).bg,color:"#C9A227",border:`1px solid ${(SPORT_COLORS[viewBooking.sport]||SPORT_COLORS.Other).border}`,fontSize:"10px",fontWeight:700,fontFamily:"'Cormorant SC',Georgia,serif",letterSpacing:"1.5px" }}>{viewBooking.sport}</div>
            <h2 style={{ margin:"0 0 4px",fontSize:"24px",fontWeight:600 }}>{viewBooking.coach}</h2>
            <p style={{ margin:"0 0 6px",fontSize:"14px",color:"rgba(249,245,237,0.45)",fontStyle:"italic" }}>{viewBooking.day}</p>
            <p style={{ margin:"0 0 10px",fontSize:"15px",color:"#C9A227",fontFamily:"'Cormorant SC',Georgia,serif" }}>
              {formatMin(viewBooking.startMin)} — {formatMin(viewBooking.startMin + viewBooking.duration)}
              <span style={{ color:"rgba(249,245,237,0.4)",fontSize:"13px",marginLeft:"8px" }}>({viewBooking.duration<60?`${viewBooking.duration} min`:viewBooking.duration===60?"1 hour":"1½ hours"})</span>
            </p>
            {viewBooking.grade && <p style={{ margin:"0 0 14px",fontSize:"13px",color:"rgba(249,245,237,0.5)",fontFamily:"'Cormorant SC',Georgia,serif",letterSpacing:"0.5px" }}>Grade: <span style={{ color:"#C9A227" }}>{viewBooking.grade}</span></p>}
            {viewBooking.note && <div style={{ background:"rgba(201,162,39,0.07)",border:"1px solid rgba(201,162,39,0.15)",borderRadius:"4px",padding:"10px 12px",fontSize:"14px",color:"rgba(249,245,237,0.7)",marginBottom:"18px",fontStyle:"italic" }}>{viewBooking.note}</div>}
            <div style={{ height:"1px",background:"rgba(201,162,39,0.15)",marginBottom:"18px" }} />
            <div style={{ display:"flex",gap:"10px" }}>
              <button onClick={() => setViewBooking(null)} style={{ flex:1,padding:"10px",border:"1px solid rgba(201,162,39,0.2)",borderRadius:"4px",background:"transparent",color:"rgba(249,245,237,0.55)",cursor:"pointer",fontSize:"13px",fontFamily:"'Cormorant SC',Georgia,serif",letterSpacing:"1px" }}>Close</button>
              <button onClick={() => deleteBooking(viewBooking.id)} style={{ flex:1,padding:"10px",border:"1px solid rgba(180,60,60,0.4)",borderRadius:"4px",background:"rgba(100,15,15,0.6)",color:"#ffaaaa",cursor:"pointer",fontSize:"13px",fontWeight:700,fontFamily:"'Cormorant SC',Georgia,serif",letterSpacing:"1px" }}>Remove</button>
            </div>
          </div>
        </div>
      )}

      {showKnight && <KnightEasterEgg onDone={() => setShowKnight(false)} />}
    </div>
  );
}
